import classes from "./styles.module.scss";
import clsx from "classnames";
import { useState } from "react";
import PropTypes from "prop-types";
import { Container } from "react-bootstrap";
import { AccordionItem2, Title } from "@/ui";

export default function Faq({ className, title, items, defaultActiveKey, bgColor }) {
  const [active, setActive] = useState(defaultActiveKey);

  return (
    <div className={clsx(className, bgColor, classes.Faq)}>
      <Container>
        <Title title={title} />
        {items.map(({ title, body }, k) => (
          <AccordionItem2
            key={k}
            eventKey={k}
            title={title}
            body={body}
            active={k === active}
            onClick={() => setActive(k === active ? null : k)}
          />
        ))}
      </Container>
    </div>
  );
}
